import { css as emotionCss, keyframes as emotionKeyframes } from 'emotion';
import { splitStyles } from '@rexlabs/element-styles';
var keyframes = emotionKeyframes;
var css = emotionCss;
/**
 * The styles object is an object, where the keys are the identifiers you can use with
 * element styles.
 *
 * The values can be a string (= will be used as classname), an object of styles
 * (= will be turned into a classname using emotion) or a function. Functions indicate
 * dynamic styles and will be turned into styles separately. The function will receive
 * meta information e.g. tokens specific to the context (path and styles) the component
 * is rendered in.
 *
 * You can pass multiple of these values per key by using arrays.
 *
 * Element styles `splitStyles` does the detection for us and splits the value for each
 * key appropriately where needed.
 *
 * @param {Object} styles
 * @return {Objct}
 */

function StyleSheet(styles) {
  return splitStyles(styles, css);
}

StyleSheet.setCreateClass = function (fn) {
  css = fn;
};

StyleSheet.setKeyframes = function (fn) {
  keyframes = fn;
};

export { StyleSheet, css, keyframes };